import { toSnakeCase } from '../packages/utils/casing'
import ApiBase from './Api'
import { PRInputEntity } from 'types/PRInput'

const PR_INPUTS_API_PATHS = {
    PR_INPUTS: '/admin/prinputs',
}
class PRInputsApi extends ApiBase {
    async findAll() {
        const response = await this._getRequest(PR_INPUTS_API_PATHS.PR_INPUTS)

        return response as PRInputEntity[]
    }

    async archive(pr: PRInputEntity): Promise<PRInputEntity> {
        const response = (await this._patchRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/archive',
            {},
            { url: pr.url },
        )) as PRInputEntity

        return response
    }

    async unArchive(pr: PRInputEntity): Promise<PRInputEntity> {
        const response = (await this._patchRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/unarchive',
            { archived: false },
            { url: pr.url },
        )) as PRInputEntity

        return response
    }

    async connectCompanyToPR(url: string, companyId: string): Promise<{ message: string }> {
        const response = await this._postRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/connect',
            toSnakeCase({
                url,
                companyId,
            }),
        )

        return response
    }

    async disconnectCompany(companyId: string): Promise<{ message: string }> {
        const response = await this._postRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/disconnect',
            toSnakeCase({
                companyId,
            }),
        )

        return response
    }

    async block(pr: PRInputEntity): Promise<{ message: string }> {
        const response = await this._postRequest(PR_INPUTS_API_PATHS.PR_INPUTS + '/block', toSnakeCase({ url: pr.url }))

        return response
    }

    async unblock(pr: PRInputEntity): Promise<{ message: string }> {
        const response = await this._postRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/unblock',
            toSnakeCase({ url: pr.url }),
        )

        return response
    }
}

export default PRInputsApi
